/*
 * people Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { RESET_STATE } from '../auth/constants';
import {
    PERSON_CREATE_SUCCEEDED,
    PERSON_UPDATE_SUCCEEDED,
    PERSON_DELETE_SUCCEEDED
} from './constants';

import { PeopleState, PeopleActions } from './types';

const initialState: PeopleState = {};

export default function (state = initialState, action: PeopleActions) {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'payload.entities.people', {});
        case PERSON_CREATE_SUCCEEDED:
        case PERSON_UPDATE_SUCCEEDED: {
            const people = get(action, 'payload.entities.people');
            if (!people) return state;
            return {
                ...state,
                ...people
            };
        }
        case PERSON_DELETE_SUCCEEDED: {
            const copy = { ...state };
            delete copy[action.id];
            return copy;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
